import { FC } from 'react';
import {
  COPYRIGHT_TEXT,
  FEEDBACK_URL,
  SUPPORT_URL,
  PRIVACY_POLICY_URL,
  PRIVACY_POLICY_TEXT,
  SUPPORT_TEXT,
  FEEDBACK_TEXT,
  ALL_RIGHTS_RESERVED_TEXT
} from './config';
import { FooterContainerProps } from './types';
import { Box, useTheme } from '@chakra-ui/react';
import FooterLink from './FooterLink';
import FooterLinkDivider from './FooterDivider';

const Footer: FC<FooterContainerProps> = (props) => {
  const theme = useTheme();

  return (
    <Box
      as='footer'
      display='flex'
      flexDirection='row'
      padding='15px 0'
      marginTop='auto'
      borderTop={`solid 1px ${theme.colors.mediumGrey3}`}
      marginLeft='auto'
      marginRight='auto'
      justifyContent='space-between'
      maxWidth='1140px'
      width='100%'
      {...props}
    >
      <Box
        fontFamily={theme.fonts.regular}
        width='50%'
        fontSize='12px'
        lineHeight='16px'
        color={theme.colors.mediumGrey3}
        display='flex'
        alignItems='center'
        data-testid='explorer-footer-carejourney-logo-container'
      >
        <Box as='span' marginLeft='2px'>
          {`${COPYRIGHT_TEXT} ${new Date().getFullYear()} ${ALL_RIGHTS_RESERVED_TEXT}`}
        </Box>
      </Box>
      <Box
        width='50%'
        textAlign='right'
        fontFamily={theme.fonts.regular}
        fontSize='12px'
        lineHeight='16px'
        color={theme.colors.mediumGrey3}
        display='flex'
        alignItems='center'
        justifyContent='flex-end'
      >
        <FooterLink
          target='_blank'
          rel='noreferrer noopener'
          href={PRIVACY_POLICY_URL}
          dataTestId='explorer-footer-privacy-policy-button'
        >
          {PRIVACY_POLICY_TEXT}
        </FooterLink>
        <FooterLinkDivider>•</FooterLinkDivider>
        <FooterLink
          target='_blank'
          rel='noreferrer noopener'
          href={SUPPORT_URL}
          dataTestId='explorer-footer-support-button'
        >
          {SUPPORT_TEXT}
        </FooterLink>
        <FooterLinkDivider>•</FooterLinkDivider>
        <FooterLink
          target='_blank'
          rel='noreferrer noopener'
          href={FEEDBACK_URL}
          dataTestId='explorer-footer-feedback-button'
        >
          {FEEDBACK_TEXT}
        </FooterLink>
      </Box>
    </Box>
  );
};

export default Footer;
